module.exports = __webpack_public_path__ + "img/search.2da959c5.svg";